'use strict';

wbApp.controller('AttendanceCtrl', ['$scope', '$document', '$http', '$window', 'notificationSvc', '$translate', '$timeout', '$modal', 
    'tenantSettingSvc', 'securitySvc', 'gridSortSvc', 'courseRegistrationSvc', 'messageBoxSvc',
function ($scope, $document, $http, $window, notificationSvc, $translate, $timeout, $modal, 
          tenantSettingSvc, securitySvc, gridSortSvc, courseRegistrationSvc, messageBoxSvc) {
    var data = courses;

    $scope.tabs = [
        {
            title: 'TXT_TAB_COURSE_SELECTION',
            template: 'attendance/course-selection-tab.html'
        },
        {
            title: 'TXT_TAB_LESSON_SELECTION',
            template: 'attendance/lesson-selection-tab.html'
        },
        {
            title: 'TXT_TAB_ATTENDANCE',
            template: 'attendance/attendance-selection-tab.html'
        },
        {
            title: 'TXT_TAB_STUDENT',
            template: 'attendance/student-detail-tab.html'
        }];

    $scope.tabs.activeTab = 0;

    $scope.courses = data;
    $scope.availableCourseTypes = _.keyBy(_.uniq(_.map($scope.courses, 'courseTypeID')));

    $scope.semesterID = semesterID;

    $scope.selectedStudent = { studentID: 0, isNew: true, attendanceCount: 1 };

    $scope.scrollPos = {};
    $scope.serverError = null;
    
    $scope.compensationGroupOverride = securitySvc.isInRole('CompensationGroupOverride');
    $scope.printLessonAttendanceVisible = securitySvc.isInRole('ClientAttendance.LessonAttendanceReport') && securitySvc.isInRole('Reports');

    $scope.tenantSettings = tenantSettingSvc.settings;
    $scope.showBarcodeFilterButton = tenantSettingSvc.settings.infoCardBackUseLogo === 2;

    $scope.setSelectedCourse = function (course) {
        $scope.selectedCourse = course;
        advanceTab($scope.tabs, $scope.scrollPos);
    }

    function selectNearestCourse(courses) {
        var now = moment();
        var nowDay = now.isoWeekday();
        for (var c = 0; c < courses.length; c++) {
            var course = courses[c];
            var firstDate = moment(course.firstDate);
            var day = firstDate.isoWeekday();

            if (day === nowDay) {
                $scope.selectedCourse = course;
                return;
            }                                 
        }
    }

    $scope.barcodeInputVisible = false;
    
    $scope.filterByCourseRegistrationCode = function(code) {
        courseRegistrationSvc.getInfoFromCourseRegistrationBarcode(code).$promise.then(
            function (result) {
                if (!result.exactMatchFound || result.errorMessage) {
                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_SERVER_ERROR'),
                        result.errorMessage);
                } else {
                    if ($scope.semesterID != result.semesterId) {
                        notificationSvc.notifyError(
                            $translate.instant('TXT_ALERT_SERVER_ERROR'),
                            $translate.instant('TXT_BARCODE_SCAN_SEARCH_FAILED'));
                        return;
                    }
                    $scope.selectedCourse = _.find(courses, function(c) { return c.courseID == result.courseId } );
                    if ($scope.selectedCourse) {
                        getCourseSchedules($scope.selectedCourse.courseID)
                            .success(function (data, status, headers, config) {
                                $scope.selectedSchedule = _.find(data, function (s) {
                                    return s.courseScheduleID == result.courseScheduleId;
                                });
                                $scope.schedules = data;

                                getLessonAttendance($scope.selectedSchedule.courseScheduleID)
                                    .success(function (data, status, headers, config) {
                                        $scope.studentSelectionTabTitle =
                                            ($scope.selectedCourse.courseAbbreviation ? $scope.selectedCourse.courseAbbreviation + " - " : "") +
                                            $scope.selectedCourse.subjectName + " - " +
                                            $scope.selectedCourse.courseName + " - " +
                                            $scope.selectedSchedule.scheduleDate;
                                        
                                        $scope.selectedStudent = _.find(data, function (s) {
                                            return s.studentID == result.studentId;
                                        })
                                        $scope.attendances = _.sortBy(data, function (a) {
                                            return gridSortSvc.sortHumanFullName2(a, 'fullName');
                                        });
                                        $scope.tabs.activeTab = 2;
                                    })
                                    .error(function (data, status, headers, config) {
                                        $scope.selectedStudent = {};
                                        notificationSvc.notifyError(
                                            $translate.instant('TXT_ALERT_SERVER_ERROR'),
                                            notificationSvc.translateError(data));
                                    });
                            });
                    }
                    
                }
            },
            function (errorResult) {
                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_SERVER_ERROR'),
                    notificationSvc.translateError(errorResult));
            }
        )
    }
    
    $scope.showBarcodeInputDlg = function() {
        if (!$scope.barcodeInputVisible) {
            $scope.barcodeInputVisible = true;

            messageBoxSvc.showMessageDlg({
                title: 'TXT_BARCODE_FILTER_TITLE',
                message: 'TXT_BARCODE_FILTER_DESC',
                input: true,
                inputPlaceholder: 'TXT_BARCODE_FILTER_PLACEHOLDER',
                onHide: function (input) {
                    $scope.barcodeInputVisible = false;
                    if (input) {
                        $scope.filterByCourseRegistrationCode(input);
                    }
                },
                buttons: [{
                    text: 'TXT_BTN_OK'
                }]
            });
        }
    }
    
    $document.bind("keydown", function(event) {
        if (!!event && event.key.toLowerCase() === 'x' && !!event.ctrlKey) {
            event.preventDefault();
            $scope.$apply(function () {
                $scope.showBarcodeInputDlg();
            });
        }
    });
    
    $scope.showCopyPhoneNumbersTooltip = false;

    $scope.copyPhoneNumbers = function(attendance)
    {
        var phones = _.reduce(attendance, function (sum, n) {
            if (!!n.phone1) {
                if (!!sum) {
                    return sum + '\n' + n.phone1;
                } else {
                    return n.phone1;
                }                 
            } else {
                return sum;
            }
        }, "");

        if (!!phones) {
            var $temp_input = $("<textarea>");
            $("body").append($temp_input);
            $temp_input.val(phones).select();
            document.execCommand("copy");
            $temp_input.remove();

            notificationSvc.notifyInfo($translate.instant('TXT_COPIED_TO_CLIPBOARD'));
        }
    }

    selectNearestCourse($scope.courses);

    $scope.setSelectedSchedule = function (schedule) {
        $scope.selectedSchedule = schedule;
        advanceTab($scope.tabs, $scope.scrollPos);
    }

    $scope.setSelectedStudent = function (student) {
        $scope.selectedStudent = student;
        advanceTab($scope.tabs, $scope.scrollPos);
    }

    $scope.editLessonNote = function (schedule) {
        $scope.noteChangeModal.schedule = schedule;
        $scope.noteChangeModal.lessonNote = schedule.lessonNote;

        noteChangeModalPromise.$promise.then(function () {
            noteChangeModalPromise.show();
        });
    }

    $scope.showRegistrationNote = function (student) {

        $http({
            method: 'GET',
            url: '/Attendance/GetRegistrationNote',
            params: {
                CourseID: $scope.selectedCourse.courseID,
                StudentID: student.studentID
            }
        }).success(function (data, status, headers, config) {
            registrationNotePromise.$promise.then(function () {
                if (data) {
                    registrationNotePromise.$scope.registrationNoteDetail = {
                        operatorFullName: data.operatorFullName,
                        note: student.registrationNote,
                        attendanceNote: student.note,
                        health: data.studentHealth,
                        attendantHealth: data.attendantHealth
                    };
                } else {
                    registrationNotePromise.$scope.registrationNoteDetail = {};
                }
                registrationNotePromise.show();
            });
        }).error(function (data, status, headers, config) {
            notificationSvc.notifyError(
                $translate.instant('TXT_ALERT_SERVER_ERROR'),
                notificationSvc.translateError(data));
        });
    }

    $scope.onStudentChange = function (selectedStudent) {
        $scope.selectedStudent.compensationCourseID = null;
        $scope.selectedStudent.attendanceCount = 1;
        $scope.serverError = null;
    }

    $scope.onAttendanceTypeChange = function () {
        $scope.serverError = null;
        $scope.selectedStudent.attendanceCount = 1;
    }

    $scope.isAttendanceTypeDisabled = function () {

        if (!$scope.selectedSchedule ||
               !$scope.selectedCourse ||
               !$scope.selectedStudent.studentID) {
            return true;
        } else {
            if (!$scope.selectedStudent.isNew) {
                if ($scope.selectedStudent.attendanceType === 0) {
                    return true;
                }
            }
            return false;
        }
    }

    $scope.isCompensationLookupDisabled = function () {
        return $scope.isAttendanceTypeDisabled();
    }

    $scope.onLessonNoteChange = function (schedule, lessonNote, sendNotification) {
        schedule.lessonNote = lessonNote;
        $http({
            method: 'POST',
            url: '/Attendance/UpdateScheduleNote',
            data: { CourseScheduleID: schedule.courseScheduleID, LessonNote: lessonNote, SendNotification: sendNotification }
        });
    }

    $scope.onPrevBtnClick = function () {
        regressTab($scope.tabs, $scope.scrollPos);
    }

    $scope.onNextBtnClick = function () {
        advanceTab($scope.tabs, $scope.scrollPos);
    }

    $scope.onSaveBtnClick = function (course, schedule, student) {
        if (student.isNew) {
            insertStudentAttendance(course, schedule, student);
        } else {
            uppdateStudentAttendanceImpl(schedule, student)
            .success(function (data, status, headers, config) {
                notificationSvc.notifyInfo(
                    $translate.instant('TXT_ALERT_ATTENDANCE_SAVE_SUCCESS'));
                regressTab($scope.tabs, $scope.scrollPos);
            }).error(function (data, status, headers, config) {
                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_ATTENDANCE_SAVE_FAILURE'),
                    notificationSvc.translateError(data));
                $scope.serverError = data;
            });
        }
    }

    $scope.onAddBtnClick = function (schedule) {
        advanceTab($scope.tabs, $scope.scrollPos);

        $scope.selectedStudent = {
            isNew: true,
            attendanceStatus: 0,
            attendanceType: 2,
            compensationCourseID: -1,
            studentID: null,
            attendanceCount: 1,
        };
    }

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        switch (newValue) {
            case 1:
                onLessonSelectionTabShow();
                break;
            case 2:
                onStudentSelectionTabShow();
                break;
        }
    });

    $scope.noteChangeModal = { title: "", saved: false };

    var noteChangeModalPromise = $modal({
        templateUrl: 'attendance/edit-lesson-note.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    var registrationNotePromise = $modal({
        templateUrl: 'attendance/show-registration-note.html',
        show: false,
        backdrop: true,
        scope: $scope.$new()
    });

    function uppdateStudentAttendanceImpl(schedule, student) {
        return $http({
            method: 'POST',
            url: '/Attendance/UpdateStudentAttendance',
            data: {
                CourseScheduleID: schedule.courseScheduleID,
                StudentID: student.studentID,
                attendanceStatus: student.attendanceStatus,
                attendanceType: student.attendanceType,
                attendanceCount: student.attendanceCount,
                note: student.note,
                edited: student.modified,
                compensationCourseID: student.compensationCourseID
            }
        });
    }

    $scope.saveAttendanceConfirmation = function (schedule, student) {
        uppdateStudentAttendanceImpl(schedule, student)
        .success(function (data, status, headers, config) {
            notificationSvc.notifyInfo(
                $translate.instant('TXT_ALERT_ATTENDANCE_CONFIRM_SUCCESS').f(student.fullName));
        }).error(function (data, status, headers, config) {
            notificationSvc.notifyError(
                $translate.instant('TXT_ALERT_ATTENDANCE_CONFIRM_FAILURE').f(student.fullName),
                notificationSvc.translateError(data));
        });
    }

    function uppdateStudentAttendance(schedule, student) {
        $http({
            method: 'POST',
            url: '/Attendance/UpdateStudentAttendance',
            data: {
                CourseScheduleID: schedule.courseScheduleID,
                StudentID: student.studentID,
                attendanceStatus: student.attendanceStatus,
                attendanceType: student.attendanceType,
                attendanceCount: student.attendanceCount,
                note: student.note,
                edited: student.modified,
                compensationCourseID: student.compensationCourseID
            }
        }).success(function (data, status, headers, config) {
            notificationSvc.notifyInfo(
                $translate.instant('TXT_ALERT_ATTENDANCE_SAVE_SUCCESS'));
            regressTab($scope.tabs, $scope.scrollPos);
        }).error(function (data, status, headers, config) {
            notificationSvc.notifyError(
                $translate.instant('TXT_ALERT_ATTENDANCE_SAVE_FAILURE'),
                notificationSvc.translateError(data));
            $scope.serverError = data;
        });
    }

    function insertStudentAttendance(course, schedule, student) {
        $http({
            method: 'POST',
            url: '/Attendance/InsertStudentAttendance',
            data: {
                CourseID: course.courseID,
                CourseScheduleID: schedule.courseScheduleID,
                StudentID: student.studentID,
                attendanceStatus: student.attendanceStatus,
                attendanceType: student.attendanceType,
                attendanceCount: student.attendanceCount,
                note: student.note,
                compensationCourseID: student.compensationCourseID
            }
        }).success(function (data, status, headers, config) {
            notificationSvc.notifyInfo(
                $translate.instant('TXT_ALERT_ATTENDANCE_SAVE_SUCCESS'));
            regressTab($scope.tabs, $scope.scrollPos);
        }).error(function (data, status, headers, config) {
            notificationSvc.notifyError(
                $translate.instant('TXT_ALERT_ATTENDANCE_SAVE_FAILURE'),
                notificationSvc.translateError(data));
            $scope.serverError = data;
        });
    }

    function advanceTab(tabs, scrollPos) {
        $scope.serverError = null;
        scrollPos[tabs.activeTab] = $(window).scrollTop();
        tabs.activeTab += 1;
        if (scrollPos[tabs.activeTab]) {
            $timeout(function () {
                $(window).scrollTop(scrollPos[tabs.activeTab]);
            }, 200);
        }
    }

    function regressTab(tabs, scrollPos) {
        $scope.serverError = null;
        scrollPos[tabs.activeTab] = $(window).scrollTop();
        tabs.activeTab -= 1;
        if (scrollPos[tabs.activeTab]) {
            $timeout(function () {
                $(window).scrollTop(scrollPos[tabs.activeTab]);
            }, 200);
        }
    }

    function onLessonSelectionTabShow() {
        if (!$scope.selectedCourse) {
            $scope.lessonSelectionTabTitle = $translate.instant("TXT_TITLE_ATTENDANCE_SELECT_LESSON");
            $scope.schedules = {};
            $scope.selectedSchedule = null;
            $scope.selectedStudent = {};
            $scope.attendances = {};
        } else {
            $scope.lessonSelectionTabTitle =
                $translate.instant("TXT_TITLE_ATTENDANCE_SELECT_LESSON") + " " +
                ($scope.selectedCourse.courseAbbreviation ? $scope.selectedCourse.courseAbbreviation + " - " : "") +
                $scope.selectedCourse.subjectName + " - " +
                $scope.selectedCourse.courseName;

            $scope.schedules = {};

            getCourseSchedules($scope.selectedCourse.courseID)
                .success(function (data, status, headers, config) {
                    $scope.selectedSchedule = findSelectedSchedule($scope.selectedSchedule, data);
                    $scope.schedules = data;
                })
                .error(function (data, status, headers, config) {
                    $scope.selectedSchedule = null;
                    $scope.selectedStudent = {};
                    $scope.attendances = {};
                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_SERVER_ERROR'),
                        notificationSvc.translateError(data));
                });
        }
    }

    function findSelectedSchedule(oldVal, schedules) {
        if (oldVal) {
            for (var i = 0; i < schedules.length; i++) {
                var schedule = schedules[i];
                if (oldVal.courseScheduleID === schedule.courseScheduleID) {
                    return schedule;
                }
            };
        }

        var schedulesByDate = _.sortBy(schedules, 'startDate');
        var now = moment();
        return _.find(schedulesByDate, function (s) {            
            return moment(s.startDate).isSameOrAfter(now, 'day');
        });
    }

    function findSelectedStudent(oldVal, attendances) {
        if (oldVal) {
            for (var i in attendances) {
                if (oldVal.studentID === attendances[i].studentID) {
                    return attendances[i];
                }
            };
        }
        return { studentID: 0 };
    }


    function onStudentSelectionTabShow() {
        if (!$scope.selectedSchedule || !$scope.selectedCourse) {
            $scope.studentSelectionTabTitle = "";
            $scope.attendances = {};
            $scope.selectedStudent = {};
        } else {
            $scope.studentSelectionTabTitle =
                ($scope.selectedCourse.courseAbbreviation ? $scope.selectedCourse.courseAbbreviation + " - " : "") +
                $scope.selectedCourse.subjectName + " - " +
                $scope.selectedCourse.courseName + " - " +
                $scope.selectedSchedule.scheduleDate;

            $scope.attendances = {};

            getLessonAttendance($scope.selectedSchedule.courseScheduleID)
                .success(function (data, status, headers, config) {
                    $scope.selectedStudent = findSelectedStudent($scope.selectedStudent, data);
                    $scope.attendances = _.sortBy(data, function (a) { return gridSortSvc.sortHumanFullName2(a, 'fullName'); });
                }).error(function (data, status, headers, config) {
                    $scope.selectedStudent = {};
                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_SERVER_ERROR'),
                        notificationSvc.translateError(data));
                });
        }
    }

    $scope.onPrintBtnClick = function (schedule) {
        onPrintLessonAttendance(schedule.courseScheduleID);
    }

    function onPrintLessonAttendance(courseScheduleID) {
        $window.open('/Admin/Report/LessonAttendance?CourseScheduleID=' + courseScheduleID,
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

    function getCourseSchedules(courseID) {
        return $http({
            method: 'GET',
            url: '/Attendance/GetCourseSchedules',
            params: { CourseID: courseID }
        });
    }

    function getLessonAttendance(courseScheduleID) {

        return $http({
            method: 'GET',
            url: 'Api/Attendance/GetLessonAttendance',
            params: { CourseScheduleID: courseScheduleID }
        });
    }

}]);